import Hidden from "@material-ui/core/Hidden";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import Work from "@material-ui/icons/Work";
import PastWork from "@material-ui/icons/NextWeek";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import workDetailIconOutline from "Assets/newicons/app/profile/outline/work-details-outline-16px.svg";
import workDetailIconGlyph from "Assets/newicons/app/profile/glyph/work-details-glyph-16px.svg";
import reportingOfficeIconOutline from "Assets/newicons/app/profile/outline/reporting-office-outline-16px.svg";
import reportingOfficeIconGlyph from "Assets/newicons/app/profile/glyph/reporting-office-glyph-16px.svg";
import currentExpIconOutline from "Assets/newicons/app/profile/outline/current-work-outline-16px.svg";
import currentExpIconGlyph from "Assets/newicons/app/profile/glyph/current-work-glyph-16px.svg";
import pastExpIconOutline from "Assets/newicons/app/profile/outline/past-work-outline-16px.svg";
import pastExpIconGlyph from "Assets/newicons/app/profile/glyph/past-work-glyph-16px.svg";

import { instance } from "../../../../Actions/AxiosInstance";
import "../Profile.css";
import { profilePrivacyInfo } from "../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../Actions/LanguageAction";
import If from "../../../../Component/Common/If";
import Current from "./current";
import Past from "./past";
import WorkDetails from "./workdetails";
import ReportingOffice from "./reportingoffice";

import WorkExpComponent from "./component";

class WorkExperience extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabId: 0,
      privacyData: [],
      hideButton: false,
      employeeid: "",
      showform: false,
      isShuffle: false,
      maxDate: new Date(),
      rangeDate: [],
      allEducationalDetails: [],
      educationGrades: [],
      country: [],
      stateprovince: [],
      cityzone: [],
      workroles: [],
      allExperienceDetails: [],
      allWorkDetails: [],
      educationgradeid: "",
      institutename: "",
      universityname: "",
      fromdate: "",
      todate: "",
      workroleid: "",
      selectedworkrole: {},
      companyname: "",
      companyaddress: "",
      countryid: "",
      selectedCountry: {},
      stateid: "",
      selectedState: {},
      cityid: "",
      selectedCity: {},
      companydoj: "",
      separationdate: "",
      isEdit: false,
      defaultExpMsg: true,
      defaultEduMsg: true,
      EditPerticularEdu: false,
      EditPerticularExp: false,

      minDate: new Date("01-01-1900"),

      isbuttonDisabled: false,
      currentEdit: "",
      expanded: "false",
      flag: false,
      showBtn: false,
    };
  }

  componentDidMount() {}

  getCountry() {
    instance
      .get("superuser/allcountry")
      .then((result) => {
        const country = [];
        country.push(
          { displayname: "Select Country", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ country });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getState() {
    const exp = this.state.perticularExp || {};
    if (this.state.countryid) {
      const URL = `superuser/statebycountryid/${this.state.countryid}`;
      instance
        .get(URL)
        .then((result) => {
          const stateprovince = [];
          stateprovince.push(
            { displayname: "Select State", displayvalue: "" },
            ...result.data.result,
          );
          this.setState({ stateprovince }, () => {
            // this.setState({ selectedState: stateprovince.find(x => x.displayvalue == exp.stateid) })
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      let cityzone;
      const stateprovince = [
        {
          displayname: "Select State",
          displayvalue: "",
        },
      ];
      cityzone = [
        {
          displayname: "Select City",
          displayvalue: "",
        },
      ];
      this.setState({ stateprovince, cityzone }, () => {
        // this.setState({ selectedState: this.state.stateprovince.find(x => x.displayvalue == exp.stateid) })
      });
    }
  }

  getCity() {
    const exp = this.state.perticularExp || {};
    if (this.state.stateid && this.state.countryid) {
      const URL = `superuser/citybystateid/${this.state.stateid}`;
      instance
        .get(URL)
        .then((result) => {
          const cityzone = [];
          cityzone.push(
            { displayname: "Select City", displayvalue: "" },
            ...result.data.result,
          );
          this.setState({ cityzone }, () => {
            // this.setState({ selectedCity: this.state.cityzone.find(x => x.displayvalue == exp.cityid) })
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      let cityzone;
      cityzone = [
        {
          displayname: "Select City",
          displayvalue: "",
        },
      ];
      this.setState({ cityzone }, () => {
        // this.setState({ selectedCity: this.state.cityzone.find(x => x.displayvalue == exp.cityid) })
      });
    }
  }

  GetWorkRole() {
    instance
      .get("superuser/workrole")
      .then((result) => {
        const workroles = [];
        workroles.push(
          { displayname: "Select work roles", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ workroles });
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  handleChange(selectedKey, e) {
    this.setState({ tabId: selectedKey });
  }

  updatestrength(flag) {
    if (flag == true) {
      this.props.UpdateStrength(true);
    }
  }

  render() {
    const { tabId } = this.state;
    const language = this.props.Language.emppersonaltab;
    return (
      <IntlProvider locale="en" messages={language}>
        <div
          className="vertical-tab-section"
          style={{ display: "flex", overflowY: Hidden, paddingLeft: 0 }}
        >
          <VerticalTabs
            value={tabId}
            // onChange={this.handleChange.bind(this, tabId)}
            indicatorColor="primary"
            textColor="primary"
            className="right-border width250 cursurpointer"
          >
            <MyTab
              label={
                <FormattedMessage
                  id="_TabWorkDetails"
                  defaultMessage="Work Details"
                />
              }
              // icon={<PastWork style={{ transform: "scaleX(-1)" }} />}
              icon={
                this.state.tabId == 0 ? (
                  <img src={workDetailIconGlyph} style={{ marginBottom: 0, marginRight:8 }} />
                ) : (
                  <img
                    src={workDetailIconOutline}
                    style={{ marginBottom: 0 , marginRight:8}}
                  />
                )
              }
              onClick={this.handleChange.bind(this, 0)}
              className="var-tab-heading"
            />
            <MyTab
              label={
                <FormattedMessage
                  id="_TabReportingOffice"
                  defaultMessage="Reporting Office"
                />
              }
              // icon={<PastWork style={{ transform: "scaleX(-1)" }} />}
              icon={
                this.state.tabId == 1 ? (
                  <img
                    src={reportingOfficeIconGlyph}
                    style={{ marginBottom: 0 , marginRight:8}}
                  />
                ) : (
                  <img
                    src={reportingOfficeIconOutline}
                    style={{ marginBottom: 0 , marginRight:8}}
                  />
                )
              }
              onClick={this.handleChange.bind(this, 1)}
              className="var-tab-heading reporting-office"
            />
            <MyTab
              label={
                <FormattedMessage
                  id="_TabCurrentExp"
                  defaultMessage="Current Experience"
                />
              }
              // icon={<Work />}
              icon={
                this.state.tabId == 2 ? (
                  <img src={currentExpIconGlyph} style={{ marginBottom: 0 , marginRight:8}} />
                ) : (
                  <img
                    src={currentExpIconOutline}
                    style={{ marginBottom: 0 , marginRight:8}}
                  />
                )
              }
              onClick={this.handleChange.bind(this, 2)}
              className="var-tab-heading current-experience"
            />
            <MyTab
              label={
                <FormattedMessage
                  id="_TabPastExp"
                  defaultMessage="Past Experience"
                />
              }
              // icon={<PastWork style={{ transform: "scaleX(-1)" }} />}
              icon={
                this.state.tabId == 3 ? (
                  <img src={pastExpIconGlyph} style={{ marginBottom: 0 , marginRight:8}} />
                ) : (
                  <img src={pastExpIconOutline} style={{ marginBottom: 0 , marginRight:8}} />
                )
              }
              onClick={this.handleChange.bind(this, 3)}
              className="var-tab-heading past-experience"
            />
          </VerticalTabs>

          <div
            style={{
              width: 5,
              height: 530,
              background: "#d3d3d3",
              position: "relative",
              left: -4,
              zIndex: -1,
            }}
          ></div>
          <If condition={tabId == 0}>
            <TabContainer>
              <WorkDetails {...this.state} {...this.props} />
            </TabContainer>
          </If>
          <If condition={tabId == 1}>
            <TabContainer>
              <ReportingOffice stat="past" {...this.state} {...this.props} />
            </TabContainer>
          </If>

          <If condition={tabId == 2}>
            <TabContainer>
              <Current {...this.state} {...this.props} />
            </TabContainer>
          </If>
          <If condition={tabId == 3}>
            <TabContainer>
              <Past stat="past" {...this.state} {...this.props} />
            </TabContainer>
          </If>
        </div>
      </IntlProvider>
    );
  }
}

const VerticalTabs = withStyles((theme) => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const MyTab = withStyles((theme) => ({
  labelContainer: {
    padding: "6px 8px",
  },
  label: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  icon: {
    display: "inline-black",
  },
}))(Tab);

function TabContainer(props) {
  return (
    <Typography
      component="div"
      className="verticaltab-innercont"
      style={{ overflow: "auto" }}
    >
      {props.children}
    </Typography>
  );
}

// ProfileTabs.propTypes = {
//     classes: PropTypes.object.isRequired,
//     theme: PropTypes.object.isRequired,
// };

const mapStateToProps = (state) => ({
  profilePrivacyInfoReducer: state.profilePrivacyInfoReducer,
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      profilePrivacyInfo: (data) => profilePrivacyInfo(data),
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(WorkExperience);
